import { render, staticRenderFns } from "./NewAccount.vue?vue&type=template&id=620666c4&scoped=true&"
import script from "./NewAccount.vue?vue&type=script&lang=js&"
export * from "./NewAccount.vue?vue&type=script&lang=js&"
import style0 from "./NewAccount.vue?vue&type=style&index=0&id=620666c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620666c4",
  null
  
)

export default component.exports